import { DateTime } from "luxon"

import { getKPIRequest } from "@/api/getKPIRequest.ts"
import type { KPIGroupRequest, KPIRequest } from "@/types/kpiTypes.ts"

import type { KPISummaryTableResponse } from "../types/kpiSummaryTableTypes.ts"

export const getKPISummaryTable = async (
  asOf: Date,
  kpis: KPIRequest[],
): Promise<KPISummaryTableResponse> => {
  const startDate = DateTime.fromJSDate(asOf).startOf("month").toISODate() || ""
  const endDate = DateTime.fromJSDate(asOf).toISODate() || ""

  const lmStartDate =
    DateTime.fromJSDate(asOf).minus({ months: 1 }).startOf("month").toISODate() || ""
  const lmEndDate = DateTime.fromJSDate(asOf).minus({ months: 1 }).endOf("month").toISODate() || ""

  const mtdReq: KPIGroupRequest = {
    startDate,
    endDate,
    aggType: "Monthly",
    kpis,
  }
  const lmReq: KPIGroupRequest = {
    startDate: lmStartDate,
    endDate: lmEndDate,
    aggType: "Monthly",
    kpis,
  }

  const [monthToDate, lastMonth] = await Promise.all([getKPIRequest(mtdReq), getKPIRequest(lmReq)])

  return {
    monthToDate,
    lastMonth,
  }
}
